<template>
  <div class="setting" v-loading="loading">
    <el-form
      :inline="true"
      label-position="left"
      label-width="100px"
      class="select-form"
      @submit.native.prevent
    >
      <el-form-item label="用户名称">
        <el-input
          v-model="search.username"
          size="small"
          placeholder="请输入分享人名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="搜索时间段">
        <el-date-picker
          size="small"
          v-model="search.timer"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="queryRankData">查询</el-button>
    </el-form>

    <el-table :data="tableData" stripe style="width: 100%" border>
      <el-table-column
        align="center"
        prop="user_id"
        label="用户Id"
      ></el-table-column>
      <el-table-column align="center" prop="avatarUrl" label="用户头像">
        <template slot-scope="scope">
          <el-image :src="scope.row.avatarUrl" style="width: 60px"></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="nickName"
        label="用户名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="redpage_first_total"
        label="一级红包数(个)"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="redpage_second_total"
        label="二级红包数(个)"
      >
      </el-table-column>
      <el-table-column align="center" prop="redpage_total" label="红包总数(个)">
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import RankApi from "@/api/rank.js";
export default {
  data() {
    return {
      loading: true,
      form: "",
      tableData: [],
      search: {
        sort: "",
        username: "",
        timer: [],
      },
      curPage: 1,
      pageSize: 1,
      total: 0,
    };
  },
  components: {},
  created() {
    this.getRankData();
    // this.queryRankData(params);
  },
  methods: {
    getRankData() {
      let params = {
        username: "",
        timer: "",
      };
      let self = this;
      RankApi.queryRedpageRank(params, false).then((res) => {
        console.log(res)
        self.tableData = res.data.data.data;
        self.total = res.data.data.total;
        self.pageSize = res.data.data.per_page;
        self.loading = false;
      });
    },
    queryRankData() {
      let self = this;
      this.loading = true;
      let params = {
        username: this.search.username,
        timer: this.search.timer,
      };
      RankApi.queryRedpageRank(params, false).then((res) => {
        self.tableData = res.data.data.data;
        self.total = res.data.data.total;
        self.pageSize = res.data.data.per_page;
        self.loading = false;
      });
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getRankData();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      // self.loading = true;
      self.getRankData();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/plus/rank/redpage.vue